import { Draft, PayloadAction, createSlice } from "@reduxjs/toolkit";

import { UserAxios } from "../../axios/user/user.axios";

import { AtiraThunk } from "../AtiraThunk";
import { User } from "../../model/user/User";
import { LoginDto } from "../../model/user/dto/LoginDto";
import { LoginResponseDto } from "../../model/user/dto/LoginResponseDto";
import { RefreshTokenDto } from "../../model/user/dto/RefreshTokenDto";

interface UserReducer {
  loggedInUserId: string | undefined;
  loggedInUser: User | undefined;
}

const initialState = Object.freeze<UserReducer>({
  loggedInUserId: undefined,
  loggedInUser: undefined,
});

const logout = AtiraThunk<void, void>(`/logout`, () => {
  localStorage.removeItem(process.env.REACT_APP_LOCAL_STORAGE_TOKEN_KEY!);
});

const refreshToken = AtiraThunk<RefreshTokenDto, void>(
  `/auth/refersh-token`,
  UserAxios.refreshToken
);

const login = AtiraThunk<LoginResponseDto, LoginDto>(
  `/user/login`,
  UserAxios.login
);

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: ({ addCase, addMatcher }) => {
    addCase(
      refreshToken.fulfilled,
      (state, action: PayloadAction<RefreshTokenDto>) => {
        localStorage.setItem(
          process.env.REACT_APP_LOCAL_STORAGE_TOKEN_KEY!,
          action.payload.token
        );
      }
    );

    addCase(logout.fulfilled, (state: Draft<UserReducer>) => {
      state.loggedInUser = undefined;
      state.loggedInUserId = undefined;
      localStorage.removeItem(process.env.REACT_APP_LOCAL_STORAGE_TOKEN_KEY!);
      localStorage.removeItem("persist:root");
    });

    addCase(
      login.fulfilled,
      (state: Draft<UserReducer>, action: PayloadAction<LoginResponseDto>) => {
        localStorage.setItem(
          process.env.REACT_APP_LOCAL_STORAGE_TOKEN_KEY!,
          action.payload.token
        );

        localStorage.setItem(process.env.REACT_APP_TOUR!, "true");

        state.loggedInUser = action.payload.user as any;
        state.loggedInUserId = action.payload.user._id as any;
      }
    );
  },
});

export const userActions = {
  logout,
  refreshToken,
  login,
};

export default userSlice.reducer;
